/**
 * @fileoverview GET handler for the "/apps/:app_group_id/user_imports/:import_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdUserImportsImportId } from "./constants";
import type { GetAppsAppGroupIdUserImportsImportIdResult } from "./types";

export const getAppsAppGroupIdUserImportsImportId = reactQueryFetcherAdapter(
  appsAppGroupIdUserImportsImportId,
  (
    signal: AbortSignal,
    appGroupId: string,
    importId: string
  ): Promise<GetAppsAppGroupIdUserImportsImportIdResult> => {
    return fetch(`/apps/${appGroupId}/user_imports/${importId}`, "GET", {}, { signal });
  }
);
